export default __webpack_public_path__ + "static/callpageShare-04fe33b00d6c39357e92e4d7babebf3b.png";